<template>
  <v-container>
    <v-card
      class="mx-auto"
      outlined
      elevation="5"
      height="200px"
    >
      <v-card-title>
        <h3 >対象店舗選択</h3>
      </v-card-title>
      <v-card-text
        class="text-left"
      >
        店舗の選択間違いに、ご注意下さい。<br>
        （選択後は、ヘッダの店舗名を確認下さい）<br><br>
        入力中の棚卸データは削除されます。
      </v-card-text>
    </v-card>
    <br>
    <h2 class="tenpo_label">対象店舗</h2>
    <v-select :options="tenpoLists" v-model="selectedTenpo" class="selectBox"  @input="setTenpo" filled></v-select>

    <div v-if="loading" id="loading">
      <v-progress-circular v-if="loading"
        :size="20"
        :width="5"
        color="purple"
      >
      </v-progress-circular>
    </div>

    <v-dialog
      v-model="api_error"
      max-width="320"
    >
      <v-card>
        <v-card-title class="headline">システムエラー</v-card-title>
        <v-card-text>
          インターネット接続を確認してください。
          もしくは、一度ログアウトを行い、
          再ログインをお願いします。
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="api_error = false"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import axios from "axios"

export default {
  name: 'TenpoSelect',
  components: {
    vSelect
  },
  data() {
    return{
      loading: false,
      api_result: null,
      api_error: false,
      selectedTenpo: {label: this.$store.state.tenpoName, code: this.$store.state.tenpoCd},
      tenpoLists: [],
    }
  },
  created() {
    axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT
    // 店舗リスト取得
    this.getTenpoData();
  },
  methods: {
    removeCache() {
      localStorage.removeItem('reloadStatus');
      this.$store.dispatch("storeDataUpdate", []);
      this.$store.dispatch("storeDataInsert", []);
      this.$store.dispatch("storeChangeItemUpdate", true);
    },
    setTenpo (){
      this.$store.dispatch("tenpo", {
        tenpoCd: this.selectedTenpo.code,
        tenpoName: this.selectedTenpo.label
      });
      this.$store.dispatch("storeData", {
        date: null,
        mode: null,
        inputData: {}
      });
      this.removeCache();
    },
    setTenpoSelector (){
      this.tenpoLists = [];
      this.api_result.forEach(element => {
        this.tenpoLists.push({label: element.fullname, code: element.an_tenpocd});
      });
    },
    getTenpoData() {
      this.loading = true,
      axios
        .get( "/api/get_tenpo_list.php",
        {
          params: {
            api_token: this.$store.state.api_token
          }
        })
        .then(
          response => (
            this.api_result = response.data,
            this.loading = false,
            this.setTenpoSelector()
          ))
        .catch(() => (
            this.loading = false,
            this.api_error = true
          ))
    },
  },
}
</script>

<style scoped>
.tenpo_label  {
  text-align: left;
}
</style>